import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SideBarProps } from "../../Dto/menu";
import { APPCONFIG } from "../../Utils/Appconfig";
import logo from "../../Assets/images/logo/camera-logo.svg";

// Add these props for responsive sidebar
// type SideBarProps = {
//   open: boolean;
//   onClose: () => void;
// };

const SideBar: React.FC<SideBarProps> = ({ openMenu, setOpenMenu }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const sidebarContent = (
        <div className="d-flex flex-column p-1" style={{ width: 265, minHeight: "100vh" }}>
            {window.innerWidth <= 768 && openMenu ?
                <div className="d-flex align-items-center m-3">
                    <img
                        src={logo}
                        alt="logo"
                    // style={{
                    //     width: 36,
                    //     height: 36,
                    //     objectFit: "cover",
                    //     marginRight: 8,
                    // }}
                    />
                    <span className="fs-5 fw-bold ms-2" style={{ color: "#222B45" }}>
                        Logo
                    </span>
                </div>
                : ""}
            <div className="list-group list-group-flush border-0">
                {APPCONFIG.MenuArray.map((menu, index) => (
                    <button
                        key={index}
                        type="button"
                        className={
                            "list-group-item list-group-item-action d-flex align-items-center border-0 " +
                            (location.pathname === menu.redirectTo ? "active" : "")
                        }
                        aria-current="true"
                        onClick={() => {
                            console.log("location.pathname", location.pathname);
                            console.log("menu.redirectTo", menu.redirectTo);

                            navigate(menu.redirectTo);
                            setOpenMenu();
                        }}
                        style={
                            location.pathname === menu.redirectTo
                                ? {
                                    color: "#2563EB",
                                    background: "#F7F9FB",
                                    borderLeft: "4px solid var(--color-primary)",
                                    fontWeight: 600,
                                }
                                : {
                                    fontWeight: 500,
                                }
                        }
                    >
                        {location.pathname === menu.redirectTo ?
                            <span className="me-3" style={{ fontSize: 18 }}>{menu.icon}</span>
                            :
                            <span className="me-3" style={{ fontSize: 18 }}>{menu.activeIcon}</span>
                        }
                        {menu.name}
                    </button>
                ))}
            </div>
        </div>
    );

    return (
        <>
            <div
                className="d-md-none"
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    zIndex: 1040,
                    display: openMenu ? "block" : "none",
                }}
            >
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"
                    style={{ zIndex: 1040 }}
                    onClick={setOpenMenu}
                />
                <div
                    className="position-fixed top-0 start-0 h-100 bg-white"
                    style={{
                        width: 260,
                        zIndex: 1041,
                        transform: openMenu ? "translateX(0)" : "translateX(-100%)",
                        transition: "transform 0.3s",
                        boxShadow: "2px 0 8px rgba(0,0,0,0.04)",
                    }}
                >
                    {sidebarContent}
                </div>
            </div>
            <div className="d-none d-md-block bg-white" style={{ width: 260, minHeight: "100vh" }}>
                {sidebarContent}
            </div>
        </>
    );
};

export default SideBar;
